import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Disease } from "../../database"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { Platform } from "react-native"
import { Toast } from "native-base"


/**
 * Model description here for TypeScript hints.
 */
export const DiseaseStoreModel = types
  .model("DiseaseStore")
  .props({
    loading: types.maybeNull(types.boolean),
    diseases: types.optional(types.array(types.frozen()), []),
    categories: types.optional(types.array(types.frozen()), []),
    // diseasesTable: types.optional(types.array(types.frozen()), []),
    isSyncing: types.optional(types.boolean, false),
    progress: types.maybeNull(types.frozen()),
    error: types.maybeNull(types.frozen()),
  })
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .extend(withRootStore)
  .extend(withEnvironment)
  .actions((self) => ({
    set: (key, value) => {
      self[key] = value;
    },
    setLoading: (loading) => {
      self.loading = loading
    },
    async getDiseases(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingDisease', true);
        const models = await Disease.fetch({
          sort: 'full_name,desc',
        }).catch((e) => {
          console.warn(e)
          self.rootStore.appStore.set("isOffline", true)
          this.set('error', e);
          return []
        })
        const categories = models.slice(0, 5);
        this.set('diseases', models.map((model) => model.toArray()));
        this.set('categories', categories);
        this.set('queryingDisease', false);
      }
      else {
        this.set('queryingDisease', true);
        this.syncDiseases().then(async () => {
          await this.getDiseases(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedDisease', true);
          this.set('queryingDisease', false);
        })
      }
    },
    async syncDiseases() {
      if (Platform.OS === 'web') return true;

      this.set('syncingDisease', true)
      const success = await Disease.syncAll(
        {},
        [], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )

      this.set('syncingDisease', false)
      return success
    },
  }))

type DiseaseStoreType = Instance<typeof DiseaseStoreModel>
export interface DiseaseStore extends DiseaseStoreType {}
type DiseaseStoreSnapshotType = SnapshotOut<typeof DiseaseStoreModel>
export interface DiseaseStoreSnapshot extends DiseaseStoreSnapshotType {}
export const createDiseaseStoreDefaultModel = () => types.optional(DiseaseStoreModel, {})
